import * as React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export interface IConfirmationModalProps {
  isOpen: boolean;
  toggle: () => void;
  title: string;
  description: any;
  disabledButton?: boolean;
  onContinue: () => void;
  textInput?: any;
  showButtons?: boolean;
  loading?:boolean;
  customClassName?: string;
}

const ConfirmationModal: React.SFC<IConfirmationModalProps> = (props: IConfirmationModalProps) => (
  <div>
    <Modal isOpen={props.isOpen} toggle={props.toggle} fade={true} contentClassName={`modal-content ${props.customClassName}`}>
      <ModalHeader toggle={props.toggle}>{props.title}</ModalHeader>
      <ModalBody>
        {props.description}
        {props.textInput}
        {props.loading && <i className="fa fa-circle-o-notch fa-spin fa-1x fa-fw notification-loader" />}
      </ModalBody>
      {
        props.showButtons !== false ?
        <ModalFooter>
          <Button color="primary" disabled={props.disabledButton} onClick={props.onContinue}>Continue</Button>
          <Button color="secondary" onClick={props.toggle}>Cancel</Button>
        </ModalFooter>
        : false
      }
    </Modal>
  </div>
);

export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/share/components/ConfirmationModal/ConfirmationModal.tsx